import { Fragment } from 'react'

/**
 * Small pieces of the reference shell markup (public/pixelmojo-rebuild,
 * pixelmojo-home.html) shared by rebuilt surfaces. Everything else in a
 * rebuilt section is the reference's own class markup (sheet, container,
 * eyebrow, h-display, lede, btn, ...) styled by src/app/shell.css.
 */

/** The reference's 24px arrow (`svg.arrow`), nudged on .btn hover. */
export function Arrow({ className = 'arrow' }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      aria-hidden='true'
    >
      <path d='M5 12h14M13 6l6 6-6 6' />
    </svg>
  )
}

/** The reference's diagonal link arrow (14-16px, `.leader__more` etc.). */
export function ArrowUpRight() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      aria-hidden='true'
    >
      <path d='M7 17L17 7M8 7h9v9' />
    </svg>
  )
}

/**
 * Hero word reveal, server-rendered: each word in `.word > span` with the
 * spaces kept as text, so the heading text a crawler reads is unchanged.
 * ShellEffects only starts the transition.
 */
export function Words({ text }: { text: string }) {
  const words = text.split(' ')
  return (
    <>
      {words.map((word, i) => (
        <Fragment key={i}>
          <span className='word'>
            <span>{word}</span>
          </span>
          {i < words.length - 1 ? ' ' : null}
        </Fragment>
      ))}
    </>
  )
}

/** Disclosure chevron (points down; rotated by CSS when its control is open). */
export function Chevron() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      aria-hidden='true'
    >
      <path d='M6 9l6 6 6-6' />
    </svg>
  )
}
